import { ClientConfig } from 'client/configuration';
import { isNode } from 'client/utils/environment';
import { setCookie } from 'client/utils/cookie/helpers/set-cookie';
import { logger } from 'client/utils/logger/logger';

const EDM_IAS_DATA_COOKIE_NAME = 'edm-ias-data';
const EDM_IAS_DATA_TIMEOUT = 2000;

function setIASDataCookie(data) {
  const newCookieValue = JSON.stringify({ fr: data.fr });
  document.cookie = setCookie(EDM_IAS_DATA_COOKIE_NAME, newCookieValue, { path: '/' }, true);
}

export function getStoredIasData(iasData) {
  try {
    return JSON.parse(iasData);
  } catch {
    return null;
  }
}

/**
 * requires modern Grade A browser that supports AbortController
 */
export async function fetchWithTimeout(url) {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), EDM_IAS_DATA_TIMEOUT);

  const response = await fetch(url, {
    ...EDM_IAS_DATA_TIMEOUT,
    signal: controller.signal,
  });

  clearTimeout(id);

  return response.json();
}

/**
 * makes a request to IAS pub service that returns user data
 * purpose of this function is to retrieve IAS fr flag to be used in ad targeting
 */
export async function getIasData(session, iasData) {
  if (isNode()) {
    return null; // disabled on server side
  }

  if (!session) {
    return null;
  }

  const iasDataValue = getStoredIasData(iasData);
  if (iasDataValue !== null) {
    return iasDataValue;
  }

  const windowWidth = window.innerWidth;
  const screenWidth = window.screen.width;
  const windowUrl = encodeURI(window.location.href);
  const url = ClientConfig.get('iasApiUrl')
    .replace('{windowWidth}', windowWidth)
    .replace('{screenWidth}', screenWidth)
    .replace('{windowUrl}', windowUrl)
    .replace('{visitorSession}', session);
  try {
    const responseData = await fetchWithTimeout(url);
    if (responseData.fr) {
      setIASDataCookie(responseData);
      return responseData;
    }
  } catch (error) {
    if (![error, error?.message].includes('Failed to fetch')) {
      logger.error(error, 'Error while fetching getIasData');
    }
  }
  return null;
}

export function getIvtClassName(iasData = null, isEnableIAS) {
  let isIvt = 'false';
  if (iasData !== null) {
    const iasDataValue = isEnableIAS && getStoredIasData(iasData);
    isIvt = iasDataValue?.fr ?? null;
  }
  let ivtClassName;
  if (isIvt === 'true') {
    ivtClassName = 'invisible is-ivt';
  }
  return ivtClassName;
}
